<ng-container *ngIf="generalSettingsData && averages && averages.length > 0">
  <div *ngFor="let item of averages" class="item-row">
    <div class="title">
      <strong>{{item.degree.split(' ').slice(0, 2).join(' ') }}</strong>
      {{ item.degree.split(' ').slice(2).join(' ')  }}
    </div>

    <div class="values">
      <div class="value">
        <div class="label">{{generalSettingsData.averageText}}</div>
        <div class="count">{{ item.average }}</div>
      </div>

      <div class="value">
        <div class="label">{{generalSettingsData.creditsText}}</div>
        <div class="count">{{ item.points }}</div>
      </div>
    </div>
  </div>
</ng-container>
<div *ngIf="!averages || averages.length === 0" class="item-row no-items">
  <h1>{{noGradesMessage}}</h1>
</div>
